// Implements: F-CNV-003, F-CNV-004
/**
 * The address of the conversation of one mockup, written once: the `conversation` module
 * reads and cancels through it and `startTurn` posts to it. The identifier is escaped even though the backend issues UUIDs, because it
 * comes out of a response body or an address.
 */

import { API_BASE } from "./apiBase";

export function conversationPath(mockupId: string): string {
  return `${API_BASE}/mockups/${encodeURIComponent(mockupId)}/conversation`;
}
